import React from 'react';

interface BodyTextProps {
  text: string;
  className?: string;
}

// Helper function to parse bold text (**text** -> <strong>text</strong>)
const parseBoldText = (text: string): React.ReactNode[] => {
  const parts: React.ReactNode[] = [];
  const regex = /\*\*(.*?)\*\*/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the bold
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    // Add bold text
    parts.push(<strong key={match.index} className="font-medium">{match[1]}</strong>);
    lastIndex = regex.lastIndex;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
};

export const BodyText: React.FC<BodyTextProps> = ({ text, className = "" }) => {
  const paragraphs = text.split('\n\n');
  const heading = paragraphs[0];
  const bodyText = paragraphs.slice(1).join('\n\n');

  return (
    <div className={`max-w-[600px] space-y-4 ${className}`}>
      {/* Heading - first paragraph with original styling */}
      {heading && (
        <h2 className="text-sm sm:text-base lg:text-lg [font-family:'Millionaire-Roman',Helvetica] text-black dark:text-white opacity-80 leading-relaxed">
          {parseBoldText(heading)}
        </h2>
      )}
      {/* Body text with new font styling */}
      {bodyText && (
        <div className="text-sm sm:text-base lg:text-lg [font-family:'ItemsTextTrial-Light',Helvetica] font-light text-black dark:text-white opacity-80 leading-relaxed space-y-4">
          {bodyText.split('\n\n').map((paragraph: string, index: number) => (
            <p key={index} className="leading-relaxed">
              {parseBoldText(paragraph)}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
